

import { createContext, useContext, useState, useMemo } from "react";

type MetaRequestContextType = {
  counts: Counts;
  setCounts: React.Dispatch<React.SetStateAction<Counts>>;
};

const MetaRequestContext = createContext<MetaRequestContextType | undefined>(
  undefined
);

type Counts = {
  registrant: number;
  guest: number;
};

export const MetaRequestProvider = ({
  children,
  counts,
}: {
  children: React.ReactNode;
  counts: Counts;
}) => {
  const [countsState, setCounts] = useState(counts);

  const contextValue = useMemo(() => ({
    counts: countsState, setCounts,
  }), [countsState]);

  return (
    <MetaRequestContext.Provider value={contextValue}>
      {children}
    </MetaRequestContext.Provider>
  );
};

export const useMetaRequest = () => {
  const context = useContext(MetaRequestContext);
  if (!context) {
    throw new Error("useMetaRequest must be used within a MetaRequestProvider");
  }
  return context;
};
